"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var alpinejs_1 = __importDefault(require("alpinejs"));
var intersect_1 = __importDefault(require("@alpinejs/intersect"));
var collapse_1 = __importDefault(require("@alpinejs/collapse"));
var header_1 = __importDefault(require("./components/header"));
var contentFilters_1 = __importDefault(require("./components/contentFilters"));
var productFinder_1 = __importDefault(require("./components/productFinder"));
var simpleProductFinder_1 = __importDefault(require("./components/simpleProductFinder"));
var productComparisonSeries_1 = __importDefault(require("./components/productComparisonSeries"));
var productSpecSheet_1 = __importDefault(require("./components/productSpecSheet"));
var distributorMap_1 = __importDefault(require("./components/distributorMap"));
var salesforceForms_1 = __importDefault(require("./components/salesforceForms"));
alpinejs_1.default.plugin(intersect_1.default);
alpinejs_1.default.plugin(collapse_1.default);
document.addEventListener('alpine:init', function () {
    (0, header_1.default)();
    (0, contentFilters_1.default)();
    (0, productFinder_1.default)();
    (0, simpleProductFinder_1.default)();
    (0, productComparisonSeries_1.default)();
    (0, productSpecSheet_1.default)();
    (0, distributorMap_1.default)();
    (0, salesforceForms_1.default)();
});
window.Alpine = alpinejs_1.default;
alpinejs_1.default.start();
